/* eslint-disable react/prefer-stateless-function */
/* eslint-disable import/no-unused-modules */
import React from 'react';
import FormGroup from '../../../generic/FormGroup';

import translations from '../../../../translations';

import { connect } from 'react-redux';

import { dismissMapElementConfig } from '../../../../actions/reduxActions/mapElements';

import { saveGroupElement as saveGroupElementAction } from '../../../../actions/reduxActions/groupElements';
import { getElementStyles } from '../../../graph/elements/elementStyles';
import { MAP_ELEMENT_TYPES } from '../../../../constants';
import ButtonDefault from '../../../buttons/ButtonDefault';
import ButtonPrimary from '../../../buttons/ButtonPrimary';
import { pathOr } from 'ramda';
import ConfigLayoutWrapper from '../ConfigLayoutWrapper';

/**
 * @param {String} editingToken
 * @param {String} flowId The ID of the Flow that the group element exists in
 * @param {String} id The ID of the group element (if it already exists)
 * @param {String} x The X coordinate of the group elements position on the canvas
 * @param {String} y The Y coordinate of the group elements position on the canvas
 *
 * @description This components acts as the controller for configuring the group
 * map element. Currently users can just change the name of the group.
 */
export class GroupConfiguration extends React.Component {

    constructor(props) {
        super(props);
        this.state = { groupElement: {} };
    }

    componentDidMount() {
        this.setState({
            groupElement: this.props.groupElement || {
                elementType: this.props.elementType,
                x: this.props.x,
                y: this.props.y,
                id: this.props.id,
                width: getElementStyles(MAP_ELEMENT_TYPES.group).groupElement.width,
                height: getElementStyles(MAP_ELEMENT_TYPES.group).groupElement.height,
            },
        });
    }

    render() {
        const {
            flowId,
            cancel,
            saveGroupElement,
            editingToken,
            tenantId,
            authenticationToken,
        } = this.props;

        const renderBody = () => (
            <FormGroup
                label="Name"
                isRequired
            >
                <input
                    value={this.state.groupElement.developerName}
                    onChange={(event) => {
                        this.setState({ 
                            groupElement: { 
                                ...this.state.groupElement,
                                developerName: event.target.value,
                            },
                        });
                    }}
                    maxLength="255"
                    size="25"
                    required
                    className="form-control"
                    type="text"
                />
            </FormGroup>
        );

        const renderFooter = () => [
            <ButtonDefault className="flex-child-right" onClick={() => cancel(flowId)}>
                {translations.GRAPH_config_panel_cancel}
            </ButtonDefault>,
            <ButtonPrimary
                className="margin-left"
                onClick={() => saveGroupElement(
                    this.state.groupElement,
                    flowId,
                    editingToken,
                    tenantId,
                    authenticationToken,
                    cancel,
                )}
            >
                {translations.GRAPH_config_panel_save}
            </ButtonPrimary>,
        ];

        const title = pathOr('', ['groupElement', 'developerName'], this.props);

        return (
            <ConfigLayoutWrapper
                renderHeader={() => <h3 className="margin-top-small">{`${translations['group heading']}: ${title}`}</h3>}
                renderBody={renderBody}
                renderFooter={renderFooter}
                title={title}
                elementType={MAP_ELEMENT_TYPES.group}
                onHide={() => cancel(flowId)}
                container={this.props.container}
                className="group-config"
            />
        );
    }
}

export default connect(
    ({ currentUser, groupElements }, ownProps) => ({
        groupElement: groupElements.find(ge => ge.id === ownProps.id),
        tenantId: currentUser.tenantId,
        authenticationToken: currentUser.authenticationToken,
    }),
    {
        saveGroupElement: saveGroupElementAction,
        cancel: dismissMapElementConfig,
    },
)(GroupConfiguration);
